import React from 'react';

import type { ListItemsQuery$variables } from '../../graphql/__generated__/ListItemsQuery.graphql';
import { ItemFragment } from '../../graphql/fragments/ItemFragment';
import { ListItemConnectionFragment } from '../../graphql/fragments/ListItemConnectionFragment';
import { ListItemFragment } from '../../graphql/fragments/ListItemFragment';
import { ListItemsQuery } from '../../graphql/ListItemsQuery';
import useDynamicSelector from '../../hooks/useDynamicSelector';
import DataLoader from '../../table/DataLoader';

export interface ILoaderListItem {
    varRequest: ListItemsQuery$variables;
    onUpdateData?: (rows: any[], count: number, connectionId: string, columns?: any[]) => void;
}

const nameQuery = 'listItems';

const LoaderListItem: React.FC<ILoaderListItem> = ({ varRequest, onUpdateData }) => {
    const updateFetchKey = useDynamicSelector('listItem', 'updateFetchKey');

    return (
        <DataLoader<ListItemsQuery$variables, {}>
            query={ListItemsQuery}
            fragmentList={ListItemFragment}
            fragment={ItemFragment}
            fragmentConnection={ListItemConnectionFragment}
            nameQuery={nameQuery}
            onUpdateData={(rows: any[], count: number, connectionId: string) => {
                onUpdateData && onUpdateData(rows, count, connectionId);
            }}
            varRequest={varRequest}
            externalFetchKey={updateFetchKey}
        />
    );
};

export default LoaderListItem;
